<section *ngIf="data" [attr.id]="data.anchor?.value" class="prices-table-panel">
  <h2 *ngIf="data.title?.value" class="prices-table-panel__title" #titleEl>
    {{ data.title.value }}
  </h2>
  <div
    *ngIf="data.description?.value"
    [innerHTML]="data.description.value | safe"
    class="prices-table-panel__description"
    #descriptionEl
  ></div>

  <div class="prices-table-panel__content">
    <div class="prices-table-panel__licenses">
      <div class="prices-table-panel__licenses-items">
        <app-prices-table-license-item
          *ngFor="
            let item of data.licenses.value;
            first as isFirst;
            last as isLast
          "
          [item]="item"
          [isLast]="isLast"
          [isFirst]="isFirst"
        ></app-prices-table-license-item>
      </div>
    </div>
    <div class="prices-table-panel__categories">
      <app-prices-table-category-item
        *ngFor="let category of data.categories.value; first as isFirst"
        [item]="category"
        [isFirst]="isFirst"
      ></app-prices-table-category-item>
    </div>
  </div>
</section>
